export const META_PIXEL_ID = '1643478940076010';

type PixelPayload = Record<string, string | number>;

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { callMethod?: (...args: unknown[]) => void; queue?: unknown[] };
    _fbq?: unknown;
  }
}

/** Inyecta el script base de Meta Pixel una sola vez y dispara el PageView. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return;

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod(...args);
      } else {
        fbq!.queue!.push(args);
      }
    } as NonNullable<Window['fbq']>;
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    const image = document.createElement('img');
    image.height = 1;
    image.width = 1;
    image.style.display = 'none';
    image.alt = '';
    image.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(image);
    document.body.appendChild(noscript);
  }

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

/** Dispara un evento estándar de Meta Pixel. */
export function trackPixelEvent(event: string, payload?: PixelPayload): void {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', event, payload);
}
